/**
 * Returns the stable unique key for this export session.
 */
export function getFigmaExportKey(data) {
    if (!data || typeof data !== 'object') return '';
    if (data.uniqueExportKey) return String(data.uniqueExportKey);
    return (data.fileKey || 'unknown') + '_' + (data.fileName || 'file');
  }
  
/**
 * Clear system clipboard after consuming figma data so it cannot
*/
export function clearFigmaClipboard() {
    requestAnimationFrame(function() {
      try {
        if (
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === 'function' &&
          document.hasFocus()
        ) {
          navigator.clipboard.writeText('').catch(function() {
          });
        }
      } catch (_) {
      }
    });
}